import React, {useContext, useState} from "react";
import {IconEdit, IconShieldCheck} from "@tabler/icons-react";
import {CButton, CImage, CModal} from "@app/components/Common";
import {COLORS, IMAGES} from "@app/constants";
import {Text, View} from "@/styles/reactnative";
import AccountInfoSecurityProcess from "./AccountInfoSecurityProcess";
import {useMyProfile} from "../../../../../hooks/user/myprofile";
import CIUtils from "../../../../../../utils/ciutils";
import {useTranslation} from "react-i18next";
import {useTimezone} from "../../../../../hooks/timezone";
import {ThemeContext} from "@/theme/ThemeProvider";
import ProfileEditModal from "./ProfileEditModal";
import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW} from "@utils/CalVW.tsx";
import { VITE_APP_API_MEDIA_URL } from "@/app/constants/APIKEYS";
import CustomModal from "@/app/mobile/organisms/ProfileSetting/ProfileSettingBody/MAccountSecurity/CustomModal";
import ProfileEditBody from "./ProfileEditModal/ProfileEditBody";

const AccountInfoNavBarLeftSide = () => {
  const {textw} = useContext(ThemeContext).theme.COLORS;
  const {data: myinfo} = useMyProfile();
  const {t} = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal && setShowModal(false);
  const openModal = () => {
    setShowModal(true);
  };
  return (
    <View style={{alignItems: "flex-start", justifyContent: "flex-start"}}>
      <View style={{flexDirection: "row"}}>
        <View style={{marginRight: 20}}>
          <CImage
            src={myinfo?.profileimage ? `${VITE_APP_API_MEDIA_URL}/${myinfo?.profileimage}` : IMAGES.avatar}
            alt="logo"
            width={64}
            height={64}
            resizeMode={"cover"}
            style={{borderRadius: 100}}
          />
        </View>
        <View
          style={{
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <View style={{flexDirection: "row"}}>
            <Text
              size={20}
              style={{
                fontWeight: "500",
                marginRight: 10,
              }}
            >
              {myinfo?.nickname}
            </Text>
            {/*{myinfo?.level > 0 && (*/}
            {/*  <CButton*/}
            {/*    icon={*/}
            {/*      <IconShieldCheck*/}
            {/*        size={17}*/}
            {/*        style={{*/}
            {/*          background: COLORS.primary,*/}
            {/*          color: textw,*/}
            {/*        }}*/}
            {/*      />*/}
            {/*    }*/}
            {/*    title={"Verified"}*/}
            {/*    onClick={() => {*/}
            {/*      console.log("Login");*/}
            {/*    }}*/}
            {/*    border={{ width: "1px", color: COLORS.primary }}*/}
            {/*    style={{*/}
            {/*      justifyContent: "space-between",*/}
            {/*      alignItems: "flex-start",*/}
            {/*      marginRight: 10,*/}
            {/*      flexDirection: "row-reverse",*/}
            {/*      padding: 0,*/}
            {/*      color: COLORS.primary,*/}
            {/*    }}*/}
            {/*  />*/}
            {/*)}*/}
            <CButton
              onClick={openModal}
              icon={<IconEdit size={16} style={{color: COLORS.lightGray5 , cursor:'pointer'}}/>}
            />
            <CustomModal
              open={showModal}
              onCancel={closeModal}
              title={t("profileEdit")}
              centered={true}
            >
              <ProfileEditBody closeModal={closeModal} />
            </CustomModal>
          </View>
        </View>
      </View>

      <DataContainer>
        <DataWrap>
          <DataLabel>
            UID
          </DataLabel>
          <DataText >
            {CIUtils.padId(myinfo?.id)}
          </DataText>
        </DataWrap>

        <DataWrap>
          <DataLabel>
            {t("lastLogin")}
          </DataLabel>
          <DataText >
            {useTimezone(myinfo?.lastlogin_at, "YYYY-MM-DD HH:mm:ss", 0)}
          </DataText>
        </DataWrap>

        <AccountInfoSecurityProcess/>
      </DataContainer>
    </View>
  );
};

export default React.memo(AccountInfoNavBarLeftSide);

const DataContainer = styled.div`
    display: flex;
    margin-top: 24px;
    gap: 120px;

    @media ${media.mobile} {
        flex-direction: column;
        gap: ${MobileCalVW(12)};
        width: ${MobileCalVW(275)};
    }
`

const DataWrap = styled.div`
    font-family: "Pretendard", sans-serif;
    display: flex;
    flex-direction: column;
    gap: 6px;



    @media ${media.mobile} {
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
            
    }
`

const DataLabel = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 16.71px;
    color: ${({theme}) => theme.inputPlaceholderText};

    @media ${media.mobile} {
        font-size: ${MobileCalVW(14)};
    }
`

const DataText = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 16.71px;
    color: ${({theme}) => theme.text};

    @media ${media.mobile} {
        font-size: ${MobileCalVW(14)};
    }
`